import EventActivityVue from '@/views/sa/event-activity/event-activity.vue';

const basePath = '/sa/event-activity';
const role = 'sa'; // 角色身份

export const SA_EVENT_ACTIVITY_INDEX = 'sa-event-activity-index';
export const SA_EVENT_ACTIVITY_EDIT = 'sa-event-activity-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: EventActivityVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_EVENT_ACTIVITY_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-create" */
        `@/views/${role}/event-activity/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SA_EVENT_ACTIVITY_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-success" */
        `@/views/${role}/event-activity/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
